import React from "react";
import loaderGif from "../assets/img/swish-loader.gif";

type LogoLoaderProps = {
  size?: number;
  fullScreen?: boolean;
};

export const LogoLoader: React.FC<LogoLoaderProps> = ({
  size = 160,
  fullScreen = true,
}) => {
  const image = (
    <img
      src={loaderGif}
      alt="Loading..."
      style={{ width: size, height: size }}
      className="pointer-events-none select-none"
    />
  );

  if (!fullScreen) {
    return (
      <div className="flex items-center justify-center w-full h-full">
        {image}
      </div>
    );
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80">
      {image}
    </div>
  );
};
